import { render, staticRenderFns } from "./SeminarClubCostDeduction.vue?vue&type=template&id=319aa79e&"
import script from "./SeminarClubCostDeduction.vue?vue&type=script&lang=js&"
export * from "./SeminarClubCostDeduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports